var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_80475)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9001 47.8001L31.7001 23.4001H38.2001L37.0001 47.8001H32.9001ZM34.9001 57.3001C34.0001 57.3001 33.3001 57.0001 32.7001 56.4001C32.1001 55.8001 31.8001 55.0001 31.8001 54.2001C31.8001 53.3001 32.1001 52.6001 32.7001 52.0001C33.3001 51.4001 34.1001 51.1001 34.9001 51.1001C35.7001 51.1001 36.5001 51.4001 37.1001 52.0001C37.7001 52.6001 38.0001 53.4001 38.0001 54.2001C38.0001 55.1001 37.7001 55.8001 37.1001 56.4001C36.5001 57.0001 35.7001 57.3001 34.9001 57.3001ZM5.00006 67.5001C1.20006 67.5001 -1.19994 63.4001 0.600061 60.1001L30.6001 5.1001C32.5001 1.6001 37.5001 1.6001 39.4001 5.1001L69.4001 60.1001C71.2001 63.4001 68.8001 67.5001 65.0001 67.5001H5.00006Z",
    fill: "#EA6100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_80475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.de396539dfc98f6e4b2a50d7bb8508dc.svg";
export { ForwardRef as ReactComponent };